// @flow

import React from "react";

import type { IconType } from "../Icons/Types.js.flow";
import Icon from "../Icons";
import buildColor from "../ColorPalette";

import {
  RadialProgress,
  CircleIncomplete,
  CircleComplete,
  PercentageText
} from "./styled-components";

type Props = {
  width: number,
  percent: number,
  backgroundColor: string,
  barColor: string,
  textColor: string,
  withTransition: boolean,
  icon: ?IconType,
  iconColor: string
};

const RadialLoader = ({
  width,
  percent,
  backgroundColor,
  barColor,
  textColor,
  withTransition,
  icon,
  iconColor
}: Props) => (
  <RadialProgress viewBox="0 0 100 100" width={width} icon={icon}>
    <CircleIncomplete
      cx="50"
      cy="50"
      r="41"
      backgroundColor={backgroundColor}
    />
    <CircleComplete
      cx="50"
      cy="50"
      r="35"
      percent={percent}
      barColor={barColor}
      withTransition={withTransition}
    />
    {!icon ? (
      <PercentageText
        x="50%"
        y="55%"
        transform="matrix(0, 1, -1, 0, 100, 0)"
        textColor={textColor}
      >
        {percent}%
      </PercentageText>
    ) : (
      <g data-qa-label="radialIcon">
        <Icon icon={icon} color={iconColor} size={35} />
      </g>
    )}
  </RadialProgress>
);

RadialLoader.defaultProps = {
  width: 100,
  percent: 0,
  backgroundColor: buildColor("navy", "900"),
  barColor: buildColor("blue", "500"),
  textColor: buildColor("blue", "500"),
  withTransition: true,
  icon: null,
  iconColor: buildColor("white", "100")
};

export default RadialLoader;
